import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const router = useRouter();

  const { authenticated, method, user } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      const loginPath = loginPaths[method];

      const href = `${loginPath}?${searchParams}`;

      router.replace(href);
    } else if (user?.is_student && !user?.is_email_verified) {
      if (window.location.pathname !== paths.auth.verifyEmail) {
        router.replace(paths.auth.verifyEmail);
      } else {
        setChecked(true);
      }
    } else if (user?.is_student && user?.is_email_verified && window.location.pathname === paths.auth.verifyEmail) {
      const isLocked = Boolean(user?.institute_status === 'blocked' || user?.is_dashboard_locked);
      router.replace(isLocked ? paths.studentdashboard.payfee : paths.studentdashboard.root);
    } else if (user?.is_student && (user?.institute_status === 'blocked' || user?.is_dashboard_locked)) {
      const allowedPaths = [
        paths.studentdashboard.payfee,
        '/studentdashboard/payfee',
        '/studentdashboard/fee',
        '/studentdashboard/feeparent',
        '/studentdashboard/feestudent',
        '/studentdashboard/feestudentcollect',
        '/studentdashboard/hostel',
        '/studentdashboard/mess',
      ];
      const isAllowed = allowedPaths.some((p) => window.location.pathname.startsWith(p));
      if (!isAllowed) {
        router.replace(paths.studentdashboard.payfee);
      } else {
        setChecked(true);
      }
    } else {
      setChecked(true);
    }
  }, [authenticated, method, router, user]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};
